import { expVal } from '@confluence/feature-experiments';
import {
	hasSpaceOperation,
	MANAGE_PUBLIC_LINKS,
} from '@confluence/space-utils/entry-points/graphql.ts';

type OperationCheckResult =
	| {
			operation?: string | null;
			targetType?: string | null;
	  }
	| null
	| undefined;

type OperationsArray = ReadonlyArray<OperationCheckResult> | null | undefined;

export const hasPublicLinksOperation = (
	operations: OperationsArray,
	operation: string,
	targetType: string,
): boolean =>
	(operations || []).some((op) => op?.operation === operation && op?.targetType === targetType);

type SpaceWithOperationsAndAdmin =
	| {
			operations?: OperationsArray;
			currentUser?: { isAdmin?: boolean | null } | null;
	  }
	| null
	| undefined;

export const hasManagePublicLinksOperation = (space: SpaceWithOperationsAndAdmin): boolean =>
	expVal('permissions_rbac_dependencies_callsites', 'isEnabled', false)
		? hasSpaceOperation(space?.operations, MANAGE_PUBLIC_LINKS)
		: Boolean(space?.currentUser?.isAdmin);

export const hasManagePublicLinksOperationOrUndefined = (
	space: SpaceWithOperationsAndAdmin,
): boolean | undefined => (space ? hasManagePublicLinksOperation(space) : undefined);
